import { NgModule } from '@angular/core';

import { ErrorDecoratorDirective } from './error-decorator.directive';
import { LoadingDirective } from './loading.directive';

@NgModule({
  declarations: [ErrorDecoratorDirective, LoadingDirective],
  exports: [ErrorDecoratorDirective, LoadingDirective],
})
export class DirectivesModule {}
